<title i18n="@@S_SITE_PAGE_TITLE_VZ">Verizon Connect | GPS Fleet Tracking System</title>

<ng-container *ngIf="isPlatformBrowser && (isVehicleDriverPanelLoaded$ | async)">
  <ng-container fmLoadModule="external"></ng-container>
  <span *ngIf="isRoadsideAssistanceAdmin$ | async" class="pendo-element" id="roadside-assistance-admin"></span>
  <span *ngIf="isRoadsideAssistanceReadOnly$ | async" class="pendo-element" id="roadside-assistance-read-only"></span>
</ng-container>

<fm-navbar-container *ngIf="!shouldDisableSsrApis() && loadNavbar"></fm-navbar-container>

<fm-vzc-side-drawer-container>
  <div
    *ngIf="isPlatformBrowser"
    class="main-content"
    [@expandMainWindow]="animationState"
    [class.main-content--sm]="(isFullscreen$ | async) === false && (menuItems$ | async).length > 7"
    [class.main-content--fullscreen]="isFullscreen$ | async"
  >
    <router-outlet></router-outlet>
  </div>
</fm-vzc-side-drawer-container>
